<template>
    <div v-if="team.players">
        <div v-for="pos in $store.getters.configuration.strategicPositions" :key="pos">
            <span class="h-sakali">{{pos | pos}}</span>
            <div class="card-sakali mb-2">
            <table class="table table-sm">
                <tr v-for="p in players(pos)" :key="p.id">
                    <td class="text-end" width="30"><player-avatar :player="p"/></td>
                    <td>{{p.surName}}</td>
                    <player-strength-and-age-table-cell :player="p" age-only/>
                    <td>
                        <player-strength-widget :player="p"/>
                    </td>
                </tr>
            </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import PlayerStrengthWidget from "../PlayerStregthWidget"
    import PlayerAvatar from "../PlayerAvatar"
    import PlayerStrengthAndAgeTableCell from "../PlayerStrengthAndAgeTableCell"

    export default {
        props: {
            team: Object
        },
        computed: {
            ...mapGetters(['user']),
        },
        methods: {
            ...mapActions(['messageAction', 'handleErrorAction']),
            players(pos){
                return this.team.players.filter((p) => {
                    return p.preferredStrategicPosition == pos
                })
            },
        },
        components: {
            PlayerStrengthWidget, PlayerAvatar, PlayerStrengthAndAgeTableCell
        }
    }
</script>
